import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import Button from 'components/App/Button';
import ColGroup from 'components/ColGroup';

import { convertIsoDateToString } from 'utils';

import styles from './DataTableVoucherCampaign.module.scss';

const HEADS = [
  'Mã code',
  'Loại voucher',
  'Ngày bắt đầu',
  'Ngày kết thúc',
  'Ngày hết hạn voucher',
];

const COL_WIDTHS = [2, 1, 1.2, 1.2, 1.6];
const COL_WIDTH_SUM = COL_WIDTHS.reduce((sum, width) => sum + width, 0);

const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';

const VOUCHER_TYPE_LABELS = {
  BOOKESE: 'BOOKESE',
  PARTNER: 'PARTNER',
};

const formatDateTime = (date) => {
  const formatted = convertIsoDateToString(date, DATE_TIME_FORMAT);
  return formatted || '-';
};

const formatVoucherType = (type) => VOUCHER_TYPE_LABELS[type] || type || '-';

function DataTableVoucherCampaign(props) {
  const { campaigns, onDeleteCampaign } = props;

  const renderActions = useCallback(
    (campaign) => (
      <div className="Action d-flex gap-3">
        <Button
          outline
          classes="Action__Button Action__Button__Danger"
          onClick={() => onDeleteCampaign?.(campaign)}
        >
          Xóa
        </Button>
      </div>
    ),
    [onDeleteCampaign],
  );

  return (
    <div
      className={styles.Component}
      style={{ '--voucher-campaign-table-cols': COL_WIDTH_SUM }}
    >
      {campaigns.length === 0 ? (
        <div className="NoData">Chưa có dữ liệu</div>
      ) : (
        <Table className="Table">
          <ColGroup
            list={COL_WIDTHS}
            containerWidth={COL_WIDTH_SUM}
            paddingX={0}
          />
          <thead className="Table__Header">
            <tr className="Table__Header__Row">
              {HEADS.map((head) => (
                <th key={head} className="Table__Header__Row__Content">
                  {head}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="Table__Body">
            {campaigns.map((campaign) => (
              <tr className="Table__Body__Row" key={campaign._id}>
                <td className="Table__Body__Row__Content">
                  <div className="VoucherCode">
                    <div className="VoucherCode__Info">
                      <span className="VoucherCode__Text">
                        {campaign.code || '-'}
                      </span>
                      {renderActions(campaign)}
                    </div>
                  </div>
                </td>

                <td className="Table__Body__Row__Content">
                  <div className="VoucherType">
                    {formatVoucherType(campaign.voucherType)}
                  </div>
                </td>

                <td className="Table__Body__Row__Content">
                  <div className="DateCell">
                    {formatDateTime(campaign.startAt)}
                  </div>
                </td>

                <td className="Table__Body__Row__Content">
                  <div className="DateCell">
                    {formatDateTime(campaign.endAt)}
                  </div>
                </td>

                <td className="Table__Body__Row__Content">
                  <div className="DateCell">
                    {formatDateTime(campaign.voucherExpiredAt)}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
}

DataTableVoucherCampaign.propTypes = {
  campaigns: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      code: PropTypes.string,
      voucherType: PropTypes.string,
      startAt: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]),
      endAt: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]),
      voucherExpiredAt: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]),
    }),
  ),
  onDeleteCampaign: PropTypes.func,
};

DataTableVoucherCampaign.defaultProps = {
  campaigns: [],
  onDeleteCampaign: undefined,
};

export default memo(DataTableVoucherCampaign);
